export default __webpack_public_path__ + "static/media/deleteX.3285220e.svg";